import React from 'react';

import ImportTemplatesEdit from '@components/shared/import_templates/ImportTemplatesEdit';

import { importTemplateService } from '@services/admin/importTemplateService';

export default function AdminImportTemplateNew() {
  return (
    <ImportTemplatesEdit
      importTemplateService={importTemplateService}
      role="admin"
    />
  );
}
